import MoreData from './more-data.vue'
export default MoreData
